import styled from 'styled-components';
import { mediaMax } from '../Media Template/Media Template';

export const SideBar = styled.div.attrs({ className: 'SideBar' })`
  width: 300px;
  max-width: 300px;
  margin-left: 14px;
  ${mediaMax.desktop`display: none;`};
`;

export const SideBarCard = styled.li.attrs({ className: 'SideBarCard' })`
  width: 100%;
  max-width: 726px;
  display: flex;
  flex-direction: column;
  padding: 10px 0;
  cursor: pointer;
`;

export const SideBarCardData = styled.div.attrs({
  className: 'SideBarCardData'
})`
  padding: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
`;
